<template lang="html">
    <v-container
        class="align-start"
        fill-height
    >
        <v-col class="align-self-center">
            <v-row class="no-gutters align-center justify-center">
                <v-col md="15">
                    <v-card class="v-sheet--expansion-panels--header">
                        <v-toolbar
                            color="primary"
                            dark
                            flat
                        >
                            <v-toolbar-title>Welcome to Kaoshi</v-toolbar-title>
                        </v-toolbar>

                        <p style="text-align: center; margin: 10px">
                            What do you want to do with Kaoshi?
                        </p>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-card
                                    :class="`mx-auto transaction ${can_send_money && 'selected'}`"
                                    max-width="344"
                                    @click="can_send_money = !can_send_money"
                                >
                                    <v-img
                                        src="/svg/send.svg"
                                        height="150"
                                        contain
                                    />
                                    <v-icon>mdi-check</v-icon>
                                    <v-card-title class="justify-center">
                                        Only Send Money
                                    </v-card-title>
                                </v-card>
                            </v-col>

                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-card
                                    :class="
                                        `mx-auto transaction ${can_receive_money && 'selected'}`"
                                    max-width="344"
                                    @click="can_receive_money = !can_receive_money"
                                >
                                    <v-img
                                        src="/svg/receive.svg"
                                        height="150"
                                        contain
                                    />
                                    <v-icon>mdi-check</v-icon>
                                    <v-card-title class="justify-center">
                                        Receive Money Only
                                    </v-card-title>
                                </v-card>
                            </v-col>

                            <v-col cols="12">
                                <v-card
                                    :class="
                                        `mx-auto transaction ${
                                            can_receive_money && can_send_money
                                                ? 'selected'
                                                : ''
                                        }`"
                                    max-width="344"
                                    @click="selectBoth"
                                >
                                    <v-img
                                        src="/svg/transfer.svg"
                                        height="150"
                                        contain
                                    />
                                    <v-icon>mdi-check-all</v-icon>

                                    <v-card-title class="justify-center">
                                        Send & Receive
                                    </v-card-title>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-card-actions class="mx-3 mb-1 pt-0 justify-end">
                            <v-btn
                                large
                                depressed
                                class=" white--text"
                                color="primary"
                                @click="submit"
                            >
                                Confirm
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <loading-overlay :loading="loading" />
        </v-col>

        <AccountCreatedModal v-model="showAccountCreatedModal" />

        <IntroVideoModal v-model="showIntroVideoModal" />
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex';

import emailApiFetcher from '../mixins/email-service-api.mixin';
import AccountCreatedModal from './components/settings/account-created-modal.vue';
import IntroVideoModal from './components/settings/intro-video-modal.vue';

export default {
    components: {
        AccountCreatedModal,
        IntroVideoModal,
    },
    data() {
        return {
            kaoshiCountries: [],
            can_send_money: false,
            can_receive_money: false,
            loading: true,
            messageAreLoading: true,
            showAccountCreatedModal: false,
            showIntroVideoModal: true,
        };
    },
    computed: {
        userCountry() {
            const countryAbbrev = this.$store.state.user.country_abbreviation;
            return this.kaoshiCountries.find((country) => country.abbreviation === countryAbbrev) || {};
        },
    },
    mixins: [emailApiFetcher],
    mounted() {
        const option = this.$store.state.user.options
            ? this.$store.state.user.options['send-or-receive-money']
            : null;
        if (option) {
            this.can_send_money = option.can_send_money;
            this.can_receive_money = option.can_receive_money;
        }
        this.loading = false;
        this.loadCountries();
    },
    methods: {
        ...mapMutations([
            'setOnboarding',
        ]),
        selectBoth() {
            if (this.can_send_money && this.can_receive_money)
                return (this.can_send_money = this.can_receive_money = false);

            this.can_send_money = this.can_receive_money = true;
        },
        submit() {
            const receiveMsg = `<p style="line-height: 1.5em;">To set up your account to receive money, please ${this
                .$store.state.user.can_post_offers ?
                    'verify your identity and' : ''} register your bank account ${this
                .$store.state.user.can_post_offers ?
                    'or mobile money' : ''} under the delivery method section of the settings page</p>`;

            const sendMsg = this.$store.state.user.can_post_offers
                ? `<p style="line-height: 1.5em;"> Also, to set up your account to send money, please verify your identity and register your debit card under the payment method section of the settings page</p>`
                : `<p style="line-height: 1.5em;">Also, download our extension from chrome to enable you easily shop across the various remittance services and get the best remittance service/deals</p>`;

            if (this.$store.state.user.can_post_offers) {
                return this.submitPayload();
            }

            if (this.userCountry.skip_payment_method_check && (this.can_send_money || this.can_receive_money)) {
                return this.submitPayload();
            }

            if (this.can_send_money && this.can_receive_money) {
                return this.$swal
                    .fire({
                        title: '<strong>Awesome!</strong>',
                        type: 'info',
                        html: `${receiveMsg}
                                <br />
                                    &nbsp;
                                <br />
                                ${sendMsg}`,
                        allowOutsideClick: true,
                        showCancelButton: true,
                        confirmButtonColor: '#181235',
                        cancelButtonColor: '#d33',
                        allowEscapeKey: true,
                    })
                    .then((result) => {
                        if (result.value) {
                            this.submitPayload();
                        }
                    });
            }

            if (this.can_send_money) {
                return this.$swal
                    .fire({
                        title: '<strong>Nice!</strong>',
                        type: 'info',
                        allowOutsideClick: true,
                        showCancelButton: true,
                        confirmButtonColor: '#181235',
                        cancelButtonColor: '#d33',
                        allowEscapeKey: true,
                        html: this.$store.state.user.can_post_offers
                            ? '<p style="line-height: 1.5em;"> To set up your account to send money, please verify your identity and register your debit card under the payment method section of the settings page</p>'
                            : '<p style="line-height: 1.5em;">Please download our web extension from the chrome store to enable you easily shop across the various remittance services and ensure you get the best remittance service/deals.<p>',
                    })
                    .then((result) => {
                        if (result.value) {
                            this.submitPayload();
                        }
                    });
            }

            if (this.can_receive_money) {
                return this.$swal
                    .fire({
                        title: '<strong>Hell Yeah!</strong>',
                        type: 'info',
                        html: `${receiveMsg}`,
                        allowOutsideClick: true,
                        showCancelButton: true,
                        confirmButtonColor: '#3F51B5',
                        cancelButtonColor: '#d33',
                        allowEscapeKey: true,
                    })
                    .then((result) => {
                        if (result.value) {
                            this.submitPayload();
                        }
                    });
            }

            return this.$swal.fire({
                type: 'error',
                title: '',
                text: 'Please select an option!',
            });
        },
        submitPayload() {
            const vm = this;
            const payload = {
                options: [
                    {
                        key: 'send-or-receive-money',
                        value: {
                            can_send_money: this.can_send_money,
                            can_receive_money: this.can_receive_money,
                        },
                    },
                ],
            };

            this.loading = true;
            Vue.backendApi()
                .user(this.$store.state.user.id)
                .storeOptions(payload)
                .then(onSuccess, onError);

            function onSuccess(response) {
                vm.loading = false;
                // update user options
                const user = vm.$store.state.user;

                if (!user.options) {
                    user.options = {};
                }

                user.options['send-or-receive-money'] = {
                    can_send_money: vm.can_send_money,
                    can_receive_money: vm.can_receive_money,
                };
                vm.$store.commit('storeUser', user);

                // FIXME: this is temporary fix for state. remove this
                vm.setOnboarding(false);

                vm.showAccountCreatedModal = true;
                vm.setOnboarding(true);
                return true;
            }

            function onError(err) {
                vm.loading = false;
                vm.$swal({
                    type: 'error',
                    title: 'We were unable to update your profile',
                    text: err,
                });
            }
        },
        async loadCountries() {
            try {
                const { data: countries } = await Vue.backendApi()
                    .countries()
                    .list();
                this.kaoshiCountries = countries;
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'Error loading countries',
                    text: error,
                });
            }
        },
    },
};
</script>

<style scoped>
.transaction {
    cursor: pointer;
    height: 200px;
    box-shadow: none !important;
}

.selected,
.transaction:hover {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
        0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
}

.transaction .v-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    color: #3f51b5;
    display: none;
}

.transaction.selected .v-icon {
    display: unset;
}
</style>
